import React from 'react';
import { ExclamationCircleIcon } from '@heroicons/react/24/outline';
import Aside from '#lib/components/aside.jsx';
import Dialog from '#lib/components/dialog.jsx';
import Button from '#lib/components/button.jsx';
import Input from '#lib/components/input.jsx';

export default function DeleteUserDialog(props) {
    const { isOpen, onClose, action, isLoading, isError, error, confirmationInput } = props;

    const [insertedEmail, setInsertedEmail] = React.useState('');
    const isNameTypedCorrectly = insertedEmail === confirmationInput;

    return (
        <Dialog isOpen={isOpen} onClose={onClose}>
            <Dialog.Panel className="w-full sm:w-96">
                <Dialog.CloseButton />
                <div className="flex items-center">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-red-100">
                        <ExclamationCircleIcon className="h-6 w-6 text-red-600" aria-hidden="true" />
                    </div>
                    <b className="ml-2">{_t.danger.textButton()}</b>
                </div>

                <p className="mb-3 mt-3 text-slate-800">{_t.danger.textInsertEmail()}</p>

                <form className="mt-5">
                    <div className="mb-4">
                        <div className="flex items-center">
                            <Input.Full
                                type="text"
                                name="confirm-delete-email"
                                id="confirm-delete-email"
                                onChange={(e) => setInsertedEmail(e.currentTarget.value)}
                                autoComplete="off"
                                className="w-full"
                            />
                        </div>
                    </div>
                    <Dialog.Footer color="neutral">
                        <Button
                            type="button"
                            disabled={!isNameTypedCorrectly || isLoading}
                            onClick={action}
                            className="px-3 font-bold rounded-md border border-transparent bg-red-100 text-red-700 hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                        >
                            {isLoading ? 'Loading...' : 'Delete account'}
                        </Button>
                        <Button onClick={onClose}>{_t.danger.cancel()}</Button>
                    </Dialog.Footer>
                </form>
            </Dialog.Panel>
        </Dialog>
    );
}
